// Runtime configuration accessor.
// Prefers values injected at container start via window.env (served as /env.js by the
// frontend's docker-entrypoint.sh); falls back to Vite build-time env for local dev.
// Keys are unprefixed (e.g. cfg('OKTA_CLIENT_ID') -> window.env.OKTA_CLIENT_ID
// || import.meta.env.VITE_OKTA_CLIENT_ID).
//
// The fallbacks below are listed one by one on purpose. A dynamic lookup
// (import.meta.env[`VITE_${key}`]) cannot be statically replaced, so Vite inlines the WHOLE
// import.meta.env object into the production bundle — every VITE_* variable present at build
// time, used or not. Static member access is replaced with just that key's literal, so nothing
// can ride along. Only add non-secret keys here: whatever is listed ends up public in the bundle.
const BUILD_TIME_FALLBACKS = {
  BASE_URL: import.meta.env.VITE_BASE_URL,
  ZUUL_API_BASE: import.meta.env.VITE_ZUUL_API_BASE,
  CDN_ASSETS_BASE: import.meta.env.VITE_CDN_ASSETS_BASE,
  OFFER_CDN_URL: import.meta.env.VITE_OFFER_CDN_URL,
  OKTA_ISSUER: import.meta.env.VITE_OKTA_ISSUER,
  OKTA_CLIENT_ID: import.meta.env.VITE_OKTA_CLIENT_ID,
  APM_SERVER_URL: import.meta.env.VITE_APM_SERVER_URL,
  SERVICE_NAME: import.meta.env.VITE_SERVICE_NAME,
  SERVICE_VERSION: import.meta.env.VITE_SERVICE_VERSION,
  NODE_ENV: import.meta.env.VITE_NODE_ENV,
  SPA_PREVIEW_URL: import.meta.env.VITE_SPA_PREVIEW_URL,
  LOCAL_TESTING: import.meta.env.VITE_LOCAL_TESTING,
  MCP_URL: import.meta.env.VITE_MCP_URL,
  BUILD_VERSION: import.meta.env.VITE_BUILD_VERSION,
};

export function cfg(key) {
  const w = typeof window !== 'undefined' ? window.env : undefined;
  const fromWindow = w ? w[key] : undefined;
  if (fromWindow != null && fromWindow !== '') return fromWindow;
  return BUILD_TIME_FALLBACKS[key];
}
